import { timeFormat, numberFormat } from "@custom/index";
import { conversionAmount } from "@/utils/hooks";

// 首页tabs
export const homeTabOptions = [
    {
        label: "概况",
        name: "overview",
        value: 0
    },
    // {
    //     label: "预约",
    //     name: "appointment",
    //     value: 0
    // },
    {
        label: "续租",
        name: "renewalToExamine",
        value: 0
    },
    {
        label: "退房",
        name: "checkOut",
        value: 0
    },
    // 2023-10-30-陈守亮修改权限
    // {
    //     label: "换房",
    //     name: "exchangeHouses",
    //     value: 0
    // },
    {
        label: "投诉",
        name: "complaint",
        value: 0
    },
    {
        label: "维修",
        name: "repair",
        value: 0
    }
];

// 首页搜索条件
export const timeButtons = [
    {
        label: "今日",
        name: "day"
    },
    {
        label: "本月",
        name: "month"
    }
];

// 概况tabs - 4个部分
export const overviewOptions = [
    {
        label: "运营情况",
        name: "operation-situation",
        className: "bg-white"
    },
    {
        label: "收款情况",
        name: "receipt-situation",
        className: "bg-white"
    },
    {
        label: "上月退租情况",
        name: "retire-situation",
    },

    {
        label: "逾期租户名单",
        name: "slippage-tenant",
        className: "bg-white"
    }
];

// 概况tabs - 运营情况 - 统计
export const operationOptions = [
    {
        src: require("@/assets/images/home/total.png"),
        name: "total",
        color: "#1221D6",
        label: "空置",
        desc: "空置房数",
        number: 0
    },
    {
        src: require("@/assets/images/home/known.png"),
        name: "known",
        color: "#F85851",
        label: "已占有",
        desc: "已租房数",
        number: 0
    }
];

// 概况tabs - 运营情况 - echarts
export const operationECharts = {
    tooltip: {
        trigger: "item",
        /*formatter: function (params) {
            return `${params.marker}${params.data.name}<span style="padding: 0 5px"></span> ${params.data.value}`;
        }*/
    },
    color: ["#FEE5E4", "#F85951"],
    series: [
        {
            type: "pie",
            radius: ["50%", "70%"],
            label: {
                show: false,
            },
            data: []
        }
    ]
};

// 概况tabs - 运营情况 - slider
export const operationSlider = [
    // {
    //     label: "投诉量",
    //     name: "a1",
    //     value: 0,
    //     rate: 0
    // },
    // {
    //     label: "报修量",
    //     name: "a2",
    //     value: 0,
    //     rate: 0
    // },
    // {
    //     label: "已维修量",
    //     name: "a3",
    //     value: 0,
    //     rate: 0
    // },
    {
        label: "新签约",
        name: "a4",
        value: 0,
        rate: 0
    },
];

// 概况tabs - 上月退租情况
// 2024/02/04 张晓瑜修改统一颜色及签约数量
export const retireOptions = [
    {
        label: "退租数量",
        name: "a1",
        value: 0,
        color: "rgb(24,94,198)",
    },
    {
        label: "签约数量",
        name: "a2",
        value: 0,
        // unit: "%",
        color: "rgb(24,94,198)",
    },
    {
        label: "到期退租",
        name: "a3",
        value: 0,
        color: "rgb(24,94,198)",
    },
    {
        label: "中途退租",
        name: "a4",
        value: 0,
        color: "rgb(24,94,198)",
    },
];

// 概况tabs - 收款情况
export const receiptOptions = [
    {
        label: "应收款",
        name: "a1",
        value: 0,
        color: '#F85851',
        icon: require("@/assets/images/home/need.png")
    },
    {
        label: "已收款",
        name: "a2",
        value: 0,
        color: 'aqua',
        icon: require("@/assets/images/home/already.png")
    },
    {
        label: "待收款",
        name: "a3",
        value: 0,
        color: '#5C84FB',
        icon: require("@/assets/images/home/not.png")
    },
];

// 概况tabs - 收款情况
export const receiptEChartsOptions = {
    tooltip: {
        trigger: 'item',
        formatter: function (params) {
            return `${params.marker}${params.data.name}<span style="padding: 0 5px"></span> ${params.value}%`;
        }
    },
    legend: {
        bottom: 0,
        left: 'center'
    },
    color: [
        //'#FB5951',
        '#31AB3F',
        '#FB9851'],
    series: [
        {
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
            },
            label: {
                show: false,
                position: 'center'
            },
            emphasis: {
                label: {
                    show: true,
                    fontSize: '20',
                    fontWeight: 'bold',
                    formatter: '{d}%\n{b}'
                }
            },
            labelLine: {
                show: false
            },
            data: [
                { value: 0, name: '应收款' },
                { value: 0, name: '已收款' },
                { value: 0, name: '待收款' },
            ]
        }
    ]
}

// 概况tabs - 收款情况 - 详情
export const receiptDetailOptions = [
    {
        label: "定金",
        name: "a1",
        value: 0,
    },
    {
        label: "电费",
        name: "a2",
        value: 0,
    },
    {
        label: "水费",
        name: "a3",
        value: 0,
    },
    {
        label: "租金",
        name: "a4",
        value: 0,
    },
    {
        label: "押金",
        name: "a5",
        value: 0,
    },
    {
        label: "服务费",
        name: "a6",
        value: 0,
    }
]

// 概况tabs - 小区动态
// 张晓瑜新增首页-小区动态-小区名称字段增加跳转
export function dynamicTableColumn(_this){
    return [
        {
            prop: "name",
            label: "小区名称",
            width: 180,
            className: 'column-tree',
            render: (h, {row}) => {
                const {name,children,code} = row;
                if(children){
                    return h("el-link", {
                        props: {type: "primary", underline: false},
                        on: {
                            click: () => {
                                _this.$router.push({name: "house-resource", params: {data: {code}}});
                            },
                        },
                        style: {}
                    }, name);
                }else if(name ) {
                    return h("el-link", {
                        props: {type: "primary", underline: false},
                        on: {
                            click: () => {
                                _this.$router.push({name:"house-resource", params: {datas: {name}}});
                            },
                        },
                        style: {}
                    }, name);
                }
            },
        },
        {
            prop: "sumCount",
            label: "总房数",
        },
        {
            prop: "totalOutsideArea",
            label: "总建筑面积(㎡)",
            width: 120,
        },
        {
            prop: "rent",
            label: "已租房数"
        },
        {
            prop: "renOutSideArea",
            label: "已租房源建筑面积(㎡)",
            width: 140,
        },
        {
            prop: "maintain",
            label: "报修量",
        },
        {
            prop: "maintainover",
            label: "已维修量"
        },
        {
            prop: "complaintCount",
            label: "投诉量",
        },
        {
            prop: "newcon",
            label: "新签约",
        },
        {
            prop: "rentRate",
            label: "出租率(%)",
        },
    ];
}


// 首页tabs 退房列表
export const tableCheckOutColumn = [
    {
        label: "序号",
        type: "index",
        width: 180
    },
    {
        prop: "timestamp",
        label: "申请时间",
        width: 200,
        render: (h, {row}) => {
            const timeStamp = !row.timestamp ? "" : timeFormat(new Date(row.timestamp), 'yyyy-MM-dd HH:mm:ss');
            return h("span", timeStamp);
        }
    },
    {
        prop: "title",
        label: "内容",
        showOverflowTooltip: true
  },

];

// 首页tabs 投诉列表
export const tableComplaintColumn = [
    {
        prop: "feedSn",
        label: "投诉编号",
        width: 150,
    },
    {
        prop: "content",
        label: "投诉内容",
        showOverflowTooltip: true,
    },
    {
        prop: "feedType",
        label: "投诉类型",
        width: 100,
    },
    {
        prop: "leasorName",
        label: "投诉人",
        width: 100,
    },

    {
      prop: "phone",
      label: "联系方式",
      width: 100,
    },
  {
    prop: "address",
    label: "租房地址",
    width: 200,
  },
  {
  prop: "roomType",
  label: "住房类型",
  width: 100,
  },
    {
        prop: "",
        label: "投诉时间",
        render: (h, { row }) => {
            return timeFormat(new Date(row.feedDate));
        },
        width: 150,
    },
    {
      prop: "state",
      label: "跟进状态",
      // 2023-10-9-17-32-陈守亮-修改注释状态，展示只展示一种状态
      // render: (h, { row }) => {
      //     if(row.state ==='未处理'){
      //         return row.state
      //     }else {
      //         return '已处理'
      //     }
      // },
      width: 100,
  },
    {
        prop: "feedLeasor",
        label: "处理人",
        width: 100,
    },
    {
        prop: "feedContent",
        label: "处理说明",
        showOverflowTooltip: true,
    },
    // {
    //     prop: "authFeedContent",
    //     label: "驳回说明",
    //     showOverflowTooltip: true,
    // },
];

// 首页tabs 维修列表
export const tableRepairColumn = [
    {
        prop: "repairSn",
        label: "报修编号",
    },
    {
        prop: "repairContent",
        label: "维修备注"
    },
    {
        prop: "repairTypeName",
        label: "维修项目",
    },
    {
        prop: "repairPeopleName",
        label: "联系人",
        width: 80,
    },
    {
        prop: "repairPeoplePhone",
        label: "联系方式",
    },
    {
        prop: "createTime",
        label: "报修时间",
        width: 100,
        render: (h, { row }) => {
            const {createTime} = row;
            return createTime ? timeFormat(new Date(createTime)) : "";
        }
    },
    // 2023-10-12 16:52:16 王江毅修改，没有字段无法发布特此注释 1、增加“区域”，区域参考财务管理界面
    /*{
        prop: "district",
        label: "区域",
        width: 100,
    },*/
    {
        prop: "repairAddress",
        label: "房间"
    },
    {
        prop: "maintainMan",
        label: "维修人",
        width: 80,
    },
    {
        prop: "commentdate",
        label: "维修时间",
        width: 100,
        render: (h, { row }) => {
            const {commentdate} = row;
            return commentdate ? timeFormat(new Date(commentdate)) : "";
        }
    },
    {
        prop: "statusName",
        label: "跟进状态",
        width: 100,
    },
    {
        prop: "confirmor",
        label: "确认人",
        width: 80,
    },
    // {
    //     prop: "",
    //     label: "用户评价"
    // },
    {
        prop: "auditComment",
        label: "备注"
    },
];

export function renewalTableColumn(_this) {
    return [
        {
            type: "index",
            label: "序号",
            width: 60,
        },
        {
            prop: "createdTime",
            label: "申请时间",
            render: (h, { row }) => {
                return timeFormat(new Date(row.createdTime), "yyyy-MM-dd HH:mm:ss");
            }
        },
        {
            prop: "leasor.name",
            label: "申请人",
        },
        {
            prop: "apartment.name",
            label: "房间号",
        },
        {
            prop: "leasor.tel1",
            label: "租户手机号",
        },
        {
            prop: "auditStatus",
            label: "状态",
        },
        {
            prop: "disposeUserName",
            label: "审批人",
            showOverflowTooltip: true,
        },
        {
            prop: "disposeDate",
            label: "审批时间",
            render: (h, { row }) => {
                return row.disposeDate?timeFormat(new Date(row.disposeDate), "yyyy-MM-dd HH:mm:ss"):'';
            },
            showOverflowTooltip: true,
        },
        {
            prop: "comment",
            label: "备注",
            showOverflowTooltip: true
        },
    ];
}
//逾期租户名单列表
export function slippageTableColumn(that) {
    return [
        {
            prop: "apartmentName",
            label: "房源名称",
            width: 300,
            render: (h, {row}) => {
                const {apartmentName} = row;
                return h("el-link", {
                    props: {type: "primary", underline: false},
                    on: {
                        click() {
                            that.$router.push({name: "house-resource", query: {data: {apartmerntName: apartmentName}}});
                        }
                    }
                }, apartmentName);
            }
        },
        {
            prop: "leasorType",
            label: "租户类型",
        },
        {
            prop: "leasorName",
            label: "租户名称",
            // width: 100,
            render: (h, {row}) => {
                const {leasorName} = row;
                return h("el-link", {
                    props: {type: "primary", underline: false},
                    on: {
                        click() {
                            that.$router.push({name: "tenant-management", params: {data: {leasorName}}});
                        }
                    }
                }, leasorName);
            }
        },
        {
            prop: "lateAmount",
            label: "逾期金额(元)",
        },
        {
            prop: "lateDate",
            label: "应收款日期",
        },
        {
            prop: "lateDays",
            label: "逾期天数(天)",
        },
    ];
}
// 即将到期合同
export function comingDue(that) {
    return [
        {
            prop: "contractNum",
            label: "合同编号",
            width: 125,
        },
        {
            prop: "apartmentName",
            label: "房源名称",
            width: 250,
            render: (h, {row}) => {
                const {apartmentName} = row;
                return h("el-link", {
                    props: {type: "primary", underline: false},
                    on: {
                        click() {
                            that.$router.push({name: "house-resource", query: {data: {apartmerntName: apartmentName}}});
                        }
                    }
                }, apartmentName);
            }
        },
        {
            prop: "leasorName",
            label: "租户名称",
            width: 100,
            render: (h, {row}) => {
                const {leasorName} = row;
                return h("el-link", {
                    props: {type: "primary", underline: false},
                    on: {
                        click() {
                            that.$router.push({name: "tenant-management", params: {data: {leasorName}}});
                        }
                    }
                }, leasorName);
            }
        },
        {
            prop: "leasorPhone",
            label: "租户手机号",
            width: 140,
        },
        {
            prop: "endDate",
            label: "合同结束时间",
            width: 120,
        },
        {
            prop: "remainingDays",
            label: "剩余时间",
            render: (h, {row}) => {
                const {remainingDays} = row;
                return remainingDays + '天'
            }
        },
    ];
}